import script from "./AttendanceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceDetails.vue?vue&type=style&index=0&id=235def3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235def3c"]])

export default __exports__